import { useState, useCallback } from 'react';
export const useSnackbar = () => {
    const [snackbarNotifications, setSnackbarNotifications] = useState([]);
    const [_, setToastTimeout] = useState({});
    const addNotification = useCallback(({ id, message, ...rest }) => {
        setSnackbarNotifications(prevSnackBarNotifications => {
            return prevSnackBarNotifications.concat({
                id,
                message,
                ...rest,
            });
        });
    }, []);
    const removeNotification = useCallback((id) => {
        setSnackbarNotifications(prevSnackbarNotifications => {
            return prevSnackbarNotifications.filter(notification => notification.id !== id);
        });
        setToastTimeout(prevToastTimeout => {
            delete prevToastTimeout[id];
            return prevToastTimeout;
        });
    }, [setSnackbarNotifications, setToastTimeout]);
    const scheduleNotificationForRemoval = useCallback((idToRemove, timeout) => {
        const timeoutId = window.setTimeout(() => removeNotification(idToRemove), timeout);
        setToastTimeout(prevToastTimeout => {
            if (!prevToastTimeout[idToRemove]) {
                return { ...prevToastTimeout, [idToRemove]: timeoutId };
            }
            else {
                return prevToastTimeout;
            }
        });
        return () => {
            clearTimeout(timeoutId);
        };
    }, [removeNotification]);
    return {
        snackbarNotifications,
        removeNotification,
        scheduleNotificationForRemoval,
        addNotification,
    };
};
//# sourceMappingURL=use_snackbar.js.map